import * as types from './actionTypes';
import rest from "../API/api";

export function loadClausesSuccess(clauses) {
    //debugger;
  return {type: types.LOAD_CLAUSE_SUCCESS, clauses};
}

export function deleteClausesSuccess(clauses) {
    //debugger;
    return {type: types.DELETE_CLAUSE_SUCCESS, clauses};
}

export function updateClausesSuccess(clauses) {
    //debugger;
    return {type: types.UPDATE_CLAUSE_SUCCESS, clauses};
}

export function addClausesSuccess(clauses) {
    //debugger;
    return {type: types.ADD_CLAUSE_SUCCESS, clauses};
}

export function readClauseSuccess(clause) {
    //debugger;
    return {type: types.READ_CLAUSE_SUCCESS, clause};
}


// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function loadClauses(tenant) {
    return function (dispatch) {
        //Build REST URL passing Tenant ID since Clauses is a sub document type
        let tempURL = rest.clauses + '/' + tenant._id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
               return dispatch(loadClausesSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//Makes an API call to the gateway which will update the clause with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the update so we will dispatch a store update with the new records.
export function updateClause(tenant,clause) {
    return function (dispatch) {
        //lets define some const. that we can use in the fetch calls below
        //REST API Gateway URLs
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CLAUSE" endpoint for Updates!!!!!
        let tempURL = rest.clause + '/' + clause._id;
        //Current Tenant record that we will need to update
        const clauseID = clause.id;
         //Update the main MongoDB record
        fetch(tempURL, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                Type: clause.Type,
                Required: clause.Required,
                Title: clause.Title,
                Text: clause.Text
            }),
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(updateClausesSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will add the clause under the tenant _id. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function addClause(tenant,clause) {
    return function (dispatch) {
        let tempURL = rest.clauses + '/' + tenant._id;
        fetch(tempURL, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                Type: clause.Type,
                Required: clause.Required,
                Title: clause.Title,
                Text: clause.Text
            }),
        })
            .then(response => response.json())
            .then(data => {
                return dispatch(addClausesSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}


//Makes an API call to the gateway which will read an clause with mongoDB_id that matches the one passed on the URL. API call
//will return the current record after the read so we will dispatch a store update with the new records.
export function readClauses(tenant,id) {
    return function (dispatch) {
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CLAUSE" endpoint for Adds!!!!!
        let tempURL = rest.clause + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(readClauseSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will delete the clause with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function deleteClause(tenant,id) {
    return function (dispatch) {
        //!!!!!MAKE SURE YOU USE THE SINGULAR "CLAUSE" endpoint for Deletes!!!!!
        let tempURL = rest.clause + '/' + id;
        fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(deleteClausesSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}



// WEBPACK FOOTER //
// ./src/actions/clauseActions.js